export default __webpack_public_path__ + "static/media/Keyvisual Image.3b0eecc3.jpg";